import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import logoExpande from "../../assets/expande-logo.png";
import "./ExpandePublic.css";

export default function ExpandePublicLayout({ title, children }) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);

  return (
    <div className="expub-page">
      <header className="expub-header">
        <nav className="expub-nav" aria-label="Navegación pública de Expande">
          <Link className="expub-brand" to="/expande/app">
            <img src={logoExpande} alt="Expande" />
          </Link>
          <div className="expub-links">
            <Link to="/expande/app">App</Link>
            <Link to="/expande/app/soporte">Soporte</Link>
            <Link to="/expande/app/privacidad">Privacidad</Link>
            <Link to="/expande/app/descarga-oficial">Descarga</Link>
          </div>
        </nav>
      </header>
      <main className="expub-main">{children}</main>
      <footer className="expub-footer">
        <div className="expub-nav">
          <span>© 2026 Expande. Todos los derechos reservados.</span>
        </div>
      </footer>
    </div>
  );
}
